module.exports = __webpack_public_path__ + "images/emoji/santa.9876c0473af486a4fd32.png";